import { ChotcaApiError } from "@chotca/sdk";

const ERROR_CODE_VI: Record<string, string> = {
  invalid_credentials: "Email hoặc mật khẩu không đúng.",
  account_disabled: "Tài khoản đã bị khoá. Vui lòng liên hệ hỗ trợ.",
  no_email: "Tài khoản chưa có email liên kết.",
  no_password: "Tài khoản này chưa có mật khẩu.",
  invalid_token: "Liên kết không hợp lệ hoặc đã hết hạn.",
  rate_limited: "Bạn thao tác quá nhanh. Vui lòng thử lại sau ít phút.",
  UNAUTHORIZED: "Phiên đăng nhập đã hết hạn. Vui lòng đăng nhập lại.",
  HTTP_ERROR: "Máy chủ tạm thời không phản hồi. Vui lòng thử lại.",
};

export function errMsg(err: unknown, fallback: string): string {
  if (err instanceof ChotcaApiError) {
    if (ERROR_CODE_VI[err.code]) return ERROR_CODE_VI[err.code]!;
    if (err.status === 0)
      return "Không kết nối được tới máy chủ. Kiểm tra mạng và thử lại.";
    if (err.status >= 500)
      return "Máy chủ đang gặp sự cố. Vui lòng thử lại sau ít phút.";
    return err.message || fallback;
  }
  if (err instanceof Error) {
    if (err.name === "AbortError" || /fetch|network/i.test(err.message)) {
      return "Không kết nối được tới máy chủ. Kiểm tra mạng và thử lại.";
    }
    return fallback;
  }
  return fallback;
}
